import handleLogoutAction from '../auth/Logout';

async function logOut(isApiTriggered: boolean = false): Promise<void> {
  return handleLogoutAction(isApiTriggered ? 'logout-api' : 'logout');
}

export default {
  logOut,
};
